import PlanningManager from './PlanningManager'

export default function Metas() {
  return <PlanningManager mode="metas" />
}
